import React from 'react';

function MentorT() {
  return <div></div>;
}

export default MentorT;
